import React from 'react';
import { i18nUtils } from './utils';

export const I18nContext = React.createContext({
  language: i18nUtils.DEFAULT_LANGUAGE,
  translations: {},
  t: (key, params) => (params ? String(key) : String(key)),
  setLanguage: () => {},
});

export default I18nContext;


